import { useLocation } from 'react-router';
import queryString from 'query-string';

type Props = {
  paramKey: string;
  defaultValue?: boolean;
};

export const useMeetingItemQueryParam = ({ paramKey, defaultValue }: Props) => {
  const { search } = useLocation();

  const { [paramKey]: key } = queryString.parse(search);

  const convertStringToBoolean = value => value === 'true';

  if (!key && defaultValue) return defaultValue;
  else if (!key) return null;
  else return convertStringToBoolean(key);
};
